/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateItemCommandResult } from '../../models/update-item-command-result';

export interface ApiNurseryManagerItemsUpdateItemPatch$Params {
      body?: {
'Id'?: string;
'Name'?: string;
'Description'?: string;
'CategoryId'?: string;
'File'?: Blob;
}
}

export function apiNurseryManagerItemsUpdateItemPatch(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerItemsUpdateItemPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateItemCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerItemsUpdateItemPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateItemCommandResult>;
    })
  );
}

apiNurseryManagerItemsUpdateItemPatch.PATH = '/api/NurseryManager/Items/UpdateItem';
